import _createForOfIteratorHelper from "D:/a/1/s/fed/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import { getCardId as xt, markCardAsRead as Rt } from "../Card/display/card-display.js";
import { bottomIsInView as x, topIsInView as g } from "../util/dom-utils.js";
import { Card, ControlCard } from "../Card/index.js";
import { cardToHtml as Ht } from "../Card/display/card-display.js";
import { isArray as D } from "../util/code-utils.js";
import { KeyCodes as ie } from "../util/key-codes.js";
import fe from "../l10n/l10n-manager-factory.js";
import { removeSubscription } from "../Core/remove-subscription.js";
import { logger as E, Guid as P } from "../../shared-lib/index.js";
import { BRAZE_ACTION_URI_REGEX as to } from "../util/validation-utils.js";
import { INELIGIBLE_BRAZE_ACTION_URL_ERROR_TYPES as vt, ineligibleBrazeActionURLErrorMessage as jt, getDecodedBrazeAction as eo, containsUnknownBrazeAction as dt } from "../util/braze-actions.js";
import { bottomHadImpression as kt, impressOnBottom as d, impressOnTop as j, topHadImpression as qt } from "./detect-impression.js";
import { SUBSCRIPTION_ID_DATA_ATTRIBUTE as f } from "./constants.js";
import ContentCards from "../ContentCards/content-cards.js";
export var LAST_REQUESTED_REFRESH_DATA_ATTRIBUTE = "data-last-requested-refresh";
export var SCROLL_LISTENER_ID = "data-listener-id";
export var scrollListeners = {};
export function destroyContentCardsHtml(t) {
  t && (t.className = t.className.replace("ab-show", "ab-hide"), setTimeout(function () {
    t && t.parentNode && t.parentNode.removeChild(t);
  }, ContentCards.cr));
  var e = t.getAttribute(f);
  null != e && removeSubscription(e);
  var n = t.getAttribute("data-listener-id");
  null != n && (window.removeEventListener("scroll", scrollListeners[n]), delete scrollListeners[n]);
}
export function generateContentCardsUI(t, e) {
  var n = fe.ea(),
    o = document.createElement("div");
  if (o.className = "ab-feed-body", o.setAttribute("aria-label", "Feed"), o.setAttribute("role", "feed"), null == t.lastUpdated) {
    var _t = document.createElement("div");
    _t.className = "ab-no-cards-message";
    var _e = document.createElement("i");
    _e.className = "fa fa-spinner fa-spin fa-4x ab-initial-spinner", _t.appendChild(_e), o.appendChild(_t);
  } else {
    var s = !1;
    var r = function r(e) {
      return t.nr(e);
    };
    var _iterator = _createForOfIteratorHelper(t.cards),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var a = _step.value;
        var i = a instanceof ControlCard;
        !i || t.ar() ? (o.appendChild(Ht(a, r, e, n.So())), s = s || !i) : E.error("Received a control card for a legacy news feed. Control cards are only supported with content cards.");
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    if (!s) {
      var _t2 = document.createElement("div");
      _t2.className = "ab-no-cards-message", _t2.innerHTML = n.get("NO_CARDS_MESSAGE") || "", _t2.setAttribute("role", "article"), o.appendChild(_t2);
    }
  }
  return o;
}
export function detectContentCardsImpressions(t, e) {
  if (null != t && null != e) {
    var n = [],
      o = e.querySelectorAll(".ab-card");
    t.Qn || (t.Qn = {});
    for (var _e2 = 0; _e2 < o.length; _e2++) {
      var s = xt(o[_e2]),
        r = g(o[_e2]),
        a = x(o[_e2]);
      if (t.Qn[s]) {
        r || a || Rt(o[_e2]);
        continue;
      }
      var i = qt(o[_e2]),
        l = kt(o[_e2]);
      var c = i,
        _f = l;
      if (!i && r && (i = !0, j(o[_e2])), !l && a && (l = !0, d(o[_e2])), i && l) {
        if (c && _f) continue;
        var _iterator2 = _createForOfIteratorHelper(t.cards),
          _step2;
        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var _e3 = _step2.value;
            if (_e3.id === s) {
              t.Qn[_e3.id] = !0, n.push(_e3);
              break;
            }
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
      }
    }
    n.length > 0 && t.sr(n);
  }
}
export function refreshContentCardsUI(t, e) {
  if (null == t || null == e) return;
  e.setAttribute("aria-busy", "true");
  var n = e.querySelectorAll(".ab-refresh-button")[0];
  null != n && (n.className += " fa-spin");
  var o = new Date().valueOf().toString();
  e.setAttribute("data-last-requested-refresh", o), setTimeout(function () {
    if (e.getAttribute("data-last-requested-refresh") === o) {
      var _t3 = e.querySelectorAll(".fa-spin");
      for (var _e4 = 0; _e4 < _t3.length; _e4++) _t3[_e4].className = _t3[_e4].className.replace(/fa-spin/g, "");
      var _n = e.querySelectorAll(".ab-initial-spinner")[0];
      if (null != _n) {
        var _t4 = document.createElement("span");
        _t4.innerHTML = fe.ea().get("FEED_TIMEOUT_MESSAGE") || "", null != _n.parentNode && (_n.parentNode.appendChild(_t4), _n.parentNode.removeChild(_n));
      }
      "true" === e.getAttribute("aria-busy") && e.setAttribute("aria-busy", "false");
    }
  }, ContentCards.Cr), t.dr();
}
export function contentCardsToHtml(t, e, n) {
  var o = document.createElement("div");
  o.className = "ab-feed ab-hide ab-effect-slide", o.setAttribute("role", "dialog"), o.setAttribute("aria-label", "Feed"), o.setAttribute("tabindex", "-1");
  var s = document.createElement("div");
  s.className = "ab-feed-buttons-wrapper", s.setAttribute("role", "group"), o.appendChild(s);
  var r = document.createElement("i");
  r.className = "fa fa-times ab-close-button", r.setAttribute("aria-label", "Close Feed"), r.setAttribute("tabindex", "0"), r.setAttribute("role", "button");
  var a = function a(t) {
    destroyContentCardsHtml(o), t.stopPropagation();
  };
  r.addEventListener("keydown", function (t) {
    t.keyCode !== ie.lo && t.keyCode !== ie.Ze || a(t);
  }), r.onclick = a;
  var i = document.createElement("i");
  i.className = "fa fa-refresh ab-refresh-button", t && null == t.lastUpdated && (i.className += " fa-spin"), i.setAttribute("aria-label", "Refresh Feed"), i.setAttribute("tabindex", "0"), i.setAttribute("role", "button");
  var l = function l(e) {
    refreshContentCardsUI(t, o), e.stopPropagation();
  };
  i.addEventListener("keydown", function (t) {
    t.keyCode !== ie.lo && t.keyCode !== ie.Ze || l(t);
  }), i.onclick = l, s.appendChild(i), s.appendChild(r), o.appendChild(generateContentCardsUI(t, e));
  var d = function d() {
    return detectContentCardsImpressions(t, o);
  };
  if (o.addEventListener("scroll", d), !n) {
    window.addEventListener("scroll", d);
    var _t5 = P.oe();
    scrollListeners[_t5] = d, o.setAttribute("data-listener-id", _t5);
  }
  return o;
}
export function updateContentCards(t, e, n, o, s) {
  if (!D(e)) return;
  var r = [];
  var _iterator3 = _createForOfIteratorHelper(e),
    _step3;
  try {
    for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
      var _t6 = _step3.value;
      if (_t6 instanceof Card) {
        if (_t6.url && to.test(_t6.url)) {
          var _e6 = eo(_t6.url);
          if (dt(_e6)) {
            E.error(jt(vt.Li, "Content Card"));
            continue;
          }
        }
        r.push(_t6);
      }
    }
  } catch (err) {
    _iterator3.e(err);
  } finally {
    _iterator3.f();
  }
  if (t.cards = r, t.lastUpdated = n, null != o) if (o.setAttribute("aria-busy", "false"), null == t.lastUpdated) destroyContentCardsHtml(o);else {
    var _e5 = o.querySelectorAll(".ab-feed-body")[0];
    if (null != _e5) {
      var _n2 = generateContentCardsUI(t, s);
      _e5.parentNode && _e5.parentNode.replaceChild(_n2, _e5), detectContentCardsImpressions(t, _n2.parentNode);
    }
  }
}
export function registerContentCardsSubscriptionId(t, e) {
  t && e.setAttribute(f, t);
}